// Relocate product-details section content beneath media column for quick-picks-2025
(function(){
  if(!document.body.classList.contains('template-product')) return;
  // Only run on the quick-picks-2025 suffix
  const tpl = document.body.className;
  if(!/template-product--quick-picks-2025/.test(tpl)) return;
  function move(){
    const mediaCol = document.getElementById('product-media');
    if(!mediaCol) return;
    // Find the product-details section (next section after main product normally)
    const detailsSection = Array.from(document.querySelectorAll('.shopify-section')).find(sec =>
      sec.id.includes('details') && sec.querySelector('.product-details__block'));
    if(!detailsSection) return;
    const detailsContainer = detailsSection.querySelector('.container, .reading-width') || detailsSection.firstElementChild;
    if(!detailsContainer || mediaCol.contains(detailsContainer)) return; // already moved

    // Wrapper to style after move
    const wrapper = document.createElement('div');
    wrapper.className = 'product-details-inline-moved';
    // Transfer children (avoid cloning to preserve state/events)
    while(detailsContainer.firstChild){
      wrapper.appendChild(detailsContainer.firstChild);
    }
    mediaCol.appendChild(wrapper);

    // Mark original section as moved (could hide, but leave an anchor for theme editor integrity)
    detailsSection.classList.add('product-details--moved');
    detailsSection.setAttribute('aria-hidden','true');
    detailsSection.style.display='none';

    // Adjust sticky height attribute if present to remove reference to old selector
    const stickyInfo = document.querySelector('.product-info[data-sticky-height-elems]');
    if(stickyInfo){
      const val = stickyInfo.getAttribute('data-sticky-height-elems') || '';
      if(val.includes('.cc-main-product + .cc-product-details .container')){
        stickyInfo.setAttribute('data-sticky-height-elems', '#product-media');
      }
    }
  }
  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', move);
  } else {
    move();
  }
})();
